
export default {
  getHeight() {
    const bodyHeight = document.body.clientHeight;
    const height = {
      footHeight: `${0.99}rem`,
      distanceHeight: `${1.4}rem`,
    };
    if (bodyHeight > 641) {
      height.footHeight = `${1.67}rem`;
      height.distanceHeight = `${2.08}rem`;
      return height;
    }
    height.footHeight = `${0.99}rem`;
    height.distanceHeight = `${1.4}rem`;
    return height;
  },
  removeHtml(content) {
    return content.replace(/<[^>]+>/g, '').replace(/&nbsp;/g, '');
  },

};
